export default __webpack_public_path__ + "static/4-b325bd8e93748e8ab558159d8c07c483.jpeg";